import React from 'react';
import fr from 'facet-rest';
import { pickFunction } from 'Helpers/Affordances';
import OnboardingNavbar from 'Views/Onboarding/Components/OnboardingNavbarPicker/OnboardingNavbar';

const OnboardingNavbarPicker = ({ clientResource, ...rest }) => {
  return pickFunction(clientResource, {
    [fr.relationships.onboardingNavbar.name]: () => {
      return (
        <OnboardingNavbar clientResource={clientResource} {...rest} />
      );
    },
    [fr.relationships.default.name]: () => null,
  });
};

export default OnboardingNavbarPicker;
